import React, { useEffect, useState } from 'react';
import Styles from './Style.module.scss';
import VocableLogo from '../../assets/login/vocable..svg';
import { ErrorMessage, Formik } from 'formik';
import { Form } from 'react-bootstrap';
import BSButton from 'Components/Button/BSButton';
import FormikTextField from 'Components/Form/FormikTextField';
import { HiOutlineEnvelope } from 'react-icons/hi2';
import { GoLock } from 'react-icons/go';
import { IoEyeOutline } from 'react-icons/io5';
import { IoEyeOffSharp } from 'react-icons/io5';
import { Link } from 'react-router-dom';
import _Button1 from '../../assets/login/_Button.svg';
import Google from '../../assets/login/google.svg';
import _Button2 from '../../assets/login/_Button (1).svg';
import _Button3 from '../../assets/login/_Button (2).svg';
import _Button4 from '../../assets/login/_Button (3).svg';
import { AvatarGroup } from 'Components/AvatarGroup/AvatarGroup';
import { FaStar } from 'react-icons/fa6';
import Stepper from 'Components/Stepper/Stepper';
import Ticker from 'Components/Ticker/Ticker';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { EMAIL_REGEX, PASSWORD_FORMAT } from 'constants';
import * as Yup from 'yup';
import PasswordValidationError from 'Components/Password/Error';
import { useDispatch } from 'react-redux';
import { login, register, socialLogin } from 'redux/slices/auth';
import { ROUTES } from '../../constants/routes';
import { useGoogleLogin } from '@react-oauth/google';
import { SIGNUP_MODAL_HEADING } from 'constants';
import metaPixelService from 'services/metaPixelService';

const SignUp = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  // Get email from URL params (for team invite flow)
  const emailFromInvite = searchParams.get('email') || '';

  const [showPassword, setShowPassword] = useState(false);
  const [emailSend, setEmailSend] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isError, setIsError] = useState(false);
  const steps = [0, 1, 2, 3]; // Array representing steps
  const [activeStep, setActiveStep] = useState(0); // Start with the first step

  const handleNext = () => {
    if (activeStep < steps.length - 1) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prev) => !prev);
  };

  // UPDATED: Email, first_name, and password fields
  // Pre-fill email if coming from team invite
  const initialValues = {
    email: emailFromInvite,
    first_name: '',
    password: '',
  };

  // UPDATED: Validate email, first_name, and password
  const validationSchema = Yup.object({
    email: Yup.string()
      .trim()
      .matches(EMAIL_REGEX, 'Invalid email')
      .required('Email is required.'),
    first_name: Yup.string().trim().required('First name is required.'),
    password: Yup.string()
      .required('Password is required.')
      .min(8, 'Password must be at least 8 characters.')
      .max(18, 'Password must be at most 18 characters.')
      .matches(PASSWORD_FORMAT, {
        message: PasswordValidationError(),
      }),
  });

  // UPDATED: Send email, first_name, and password
  const handleSubmit = async (values, { resetForm }) => {
    const { email, first_name, password } = values || {};
    const body = {
      user: {
        email,
        first_name,
        password,
        password_confirmation: password, // Use same password for confirmation
      },
    };

    const response = await dispatch(register(body));
    const { payload = {} } = response;

    if (payload.confirmation_required) {
      resetForm();
      handleSendEmail();
    }
    if (payload.error) {
      resetForm();
      setIsError(true);
    }
    if (payload.user?.sign_in_count < 2) {
      // CompleteRegistration is now tracked after email confirmation, not during initial signup
      // This prevents duplicate tracking and ensures proper timing

      // Check if user came from lifetime deal page
      const lifetimeDealIntent = localStorage.getItem('lifetimeDealIntent');
      if (lifetimeDealIntent) {
        localStorage.removeItem('lifetimeDealIntent');
        navigate('/payment?lifetime=true');
        return;
      }
    }
  };

  const handleSendEmail = () => {
    setEmailSend(true);
  };

  const handleGoogleLoginSuccess = async (response) => {
    const responseData = await dispatch(
      socialLogin(
        { googleAccessToken: response.access_token },
        SIGNUP_MODAL_HEADING,
      ),
    );
    const { payload = {} } = responseData || {};
    if (payload.user?.sign_in_count < 2) {
      // Check if user came from lifetime deal page
      const lifetimeDealIntent = localStorage.getItem('lifetimeDealIntent');
      if (lifetimeDealIntent) {
        localStorage.removeItem('lifetimeDealIntent');
        navigate('/payment?lifetime=true');
        return;
      }
      // navigate(ROUTES.OnboardingInfo);
    }
  };

  const handleGoogleLoginFailure = () => {
    renderError('Login failed, please contact with support!');
  };

  const googleLogin = useGoogleLogin({
    onSuccess: handleGoogleLoginSuccess,
    onError: handleGoogleLoginFailure,
  });

  const handleClick = (values, resetForm) => {
    handleSubmit(values, { resetForm });
  };

  return (
    <div className={Styles.OuterContainer}>
      <div className={Styles.OuterContainer__left}>
        <img
          src={VocableLogo}
          alt="logo"
          onClick={() => navigate('/')}
          style={{ cursor: 'pointer' }}
        />
        <div className={Styles.OuterContainer__left__form_container}>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            validateOnMount={true}
            enableReinitialize={true}
          >
            {({ values, setFieldValue, isValid, dirty, resetForm }) => {
              return (
                <>
                  <div
                    className={
                      Styles.OuterContainer__left__form_container__welcome
                    }
                  >
                    <p>Welcome</p>
                    <span>Sign Up and explore Vocable.ai</span>
                  </div>
                  <div>
                    <div className={Styles.logos_container}>
                      <button
                        onClick={() => googleLogin()}
                        className={Styles.google_btn}
                      >
                        <span>Continue with Google</span>
                        <img src={Google} alt="google" />
                      </button>
                    </div>
                    <div className={Styles.or_container}>
                      <div className={Styles.or_container__line}></div>
                      <div className={Styles.or_container__or}>OR</div>
                      <div className={Styles.or_container__line}></div>
                    </div>
                  </div>
                  <Form
                    className={Styles.formik_form}
                    onSubmit={(e) => {
                      e.preventDefault();
                    }}
                  >
                    {emailSend || isError ? (
                      <div className={Styles.email_send_box}>
                        <div className={Styles.email_send_box__inner_box}>
                          <div
                            className={Styles.email_send_box__inner_box__top}
                          >
                            {emailSend ? 'Verify Email' : 'Email Already Taken'}
                          </div>
                          <div
                            className={Styles.email_send_box__inner_box__bottom}
                          >
                            {emailSend
                              ? 'Signed up successfully, please verify your email address by following the instructions sent to your email.'
                              : 'Please use a different email address to register as this email is already taken.'}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <>
                        {/* REMOVED: last_name, company_name, confirm_password fields */}

                        {/* First Name field */}
                        <div className={Styles.fullWidth}>
                          <FormikTextField
                            name="first_name"
                            type="text"
                            placeholder="Enter your first name"
                            classList="input input__Email"
                            Label="First Name"
                            isRequired
                          />
                          <ErrorMessage name="first_name">
                            {(msg) => <span className="error">{msg}</span>}
                          </ErrorMessage>
                        </div>

                        {/* Email field */}
                        <div className={Styles.fullWidth}>
                          <FormikTextField
                            name="email"
                            type="email"
                            placeholder="Enter your email"
                            classList="input input__Email"
                            Label="Email"
                            isRequired
                            preIcon={<HiOutlineEnvelope color="#667085" />}
                          />
                          <ErrorMessage name="email">
                            {(msg) => <span className="error">{msg}</span>}
                          </ErrorMessage>
                        </div>

                        {/* Password field */}
                        <div className={Styles.password_field}>
                          <FormikTextField
                            name="password"
                            type={showPassword ? 'text' : 'password'}
                            placeholder="Enter password..."
                            classList="input input__Email"
                            Label="Password"
                            isRequired
                            preIcon={<GoLock color="#667085" />}
                            postIcon={
                              showPassword ? (
                                <IoEyeOffSharp
                                  color="#667085"
                                  onClick={togglePasswordVisibility}
                                />
                              ) : (
                                <IoEyeOutline
                                  color="#667085"
                                  onClick={togglePasswordVisibility}
                                />
                              )
                            }
                          />
                          <ErrorMessage name="password">
                            {(msg) => <span className="error">{msg}</span>}
                          </ErrorMessage>
                        </div>

                        <div className={Styles.btn_container}>
                          <BSButton
                            classList={`btn button secondary_btn w-100`}
                            variant="dark"
                            ButtonText="Sign Up"
                            disabled={!isValid}
                            onClick={() => handleClick(values, resetForm)}
                          />
                        </div>
                      </>
                    )}
                    <div className={Styles.trial_account}>
                      <span className={Styles.trial_account__dont_have}>
                        Already have an account?
                      </span>
                      <Link
                        to="/log-in"
                        className={Styles.trial_account__have}
                        onClick={() => navigate('/log-in')}
                      >
                        Sign In
                      </Link>
                    </div>
                  </Form>
                </>
              );
            }}
          </Formik>
        </div>
      </div>
      <div className={Styles.OuterContainer__right}>
        <div
          className="senja-embed"
          id="senja-embed"
          data-id="735d7c8f-6e55-4045-8942-ee8ae3b08e90"
          data-mode="shadow"
          data-lazyload="false"
          style={{ display: 'block', padding: '0 1rem', height: '100%' }}
        ></div>
      </div>
    </div>
  );
};

export default SignUp;
